// 'use client'

// import { ChakraProvider, defaultSystem } from '@chakra-ui/react'
// import { ColorModeProvider } from './color-mode'

// export function Provider(props) {
//   return (
//     <ChakraProvider value={defaultSystem}>
//       <ColorModeProvider {...props} />
//     </ChakraProvider>
//   )
// }

import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import theme from '../../theme.js';
import '../../styles/fonts.css'; // 폰트 CSS 불러오기

export const Provider = ({ children }) => {
  return (
    <ChakraProvider theme={theme}>
      {children}
    </ChakraProvider>
  );
};